import { ORDERS_ACTION_TYPES } from "./actionTypes";

const initialState = {
    loading: false,
    error: null,
    lastOrder: null,
    createdAt: null,
    paymentUrls: {},
};

export const ordersReducer = (state = initialState, action) => {
    switch (action.type) {
        case ORDERS_ACTION_TYPES.PUT_ORDER_REQUEST: {
            return {
                ...state,
                loading: true,
                error: null,
            };
        }

        case ORDERS_ACTION_TYPES.PUT_ORDER_SUCCESS: {
            const order = action.payload;
            const newPaymentUrls = { ...state.paymentUrls };

            if (order.payment_url) {
                newPaymentUrls[String(order.id)] = {
                    url: order.payment_url,
                    createdAt: action.meta.timestamp,
                };
            }

            return {
                ...state,
                loading: false,
                error: null,
                lastOrder: order,
                createdAt: action.meta.timestamp,
                paymentUrls: newPaymentUrls,
            };
        }

        case ORDERS_ACTION_TYPES.PUT_ORDER_FAILURE: {
            return {
                ...state,
                loading: false,
                error: action.payload.error,
            };
        }

        case ORDERS_ACTION_TYPES.FETCH_ORDER_SUCCESS: {
            return {
                ...state,
                lastOrder: action.payload,
            };
        }

        case ORDERS_ACTION_TYPES.CLEAR_ORDER_STATE: {
            return initialState;
        }

        default:
            return state;
    }
};